import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

export default class RolFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                name: '',
                descripcion: '',
            },
            colapsar: true,
            colapsarPermisos: true,
            camposRequeridos: [],
            permisos: [],
        };

        this.asociarPermiso = this.asociarPermiso.bind(this);
        this.colapsarTablaAsociar = this.colapsarTablaAsociar.bind(this);
    }

    componentDidMount() {
        this.obtenerAsociados();
    }

    obtenerAsociados() {
        const { registro } = this.state;
        if (_valid(registro.id)) {
            this.apiRest.get('/rolPermisos/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ permisos: respuesta.data });
                }
            });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (registro.id !== undefined && registro.id !== null) {
                this.apiRest.put('/rol/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/rolListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.apiRest.post('/rol', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });
                        this.props.history.replace('/rolListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    colapsarTablaAsociar = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
    }

    asociarPermiso = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idPermiso: value
        }
        this.apiRest.put('/asociarRolPermisos/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Permiso ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;

        let existenErrores = false
        if (!_valid(registro.name)) {
            camposRequeridos.push("Nombre");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), 3000);
        }

        return !existenErrores;
    }

    render() {
        const { registro, colapsar, colapsarPermisos, camposRequeridos, permisos } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Rol" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Rol</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="name" className="form-label">
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.name}
                                                                        onChange={this.actualizarValores}
                                                                        name="name"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/rolListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarTablaAsociar("colapsarPermisos")} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar permisos</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarPermisos}>
                                                <div className="p-4 border-top">
                                                    <Table className="table table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th width="15%">Asociar</th>
                                                                <th>Permisos</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                permisos.map((permiso, indice) =>
                                                                    <tr key={indice}>
                                                                        <td className="text-center">
                                                                            <Input
                                                                                type="checkbox"
                                                                                value={permiso.id}
                                                                                onChange={this.asociarPermiso}
                                                                                defaultChecked={permiso.asociado}
                                                                                className="form-control"
                                                                            />
                                                                        </td>
                                                                        <td>{permiso.name}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}